import type { Translatable } from "app/pages/sales-intelligence/types";
import SelectionItem from "../SelectionItem";

export default class ManualSelectionItem extends SelectionItem {
    static ID = "manual-selection";

    constructor(value: number, disabledReason?: Readonly<Translatable>, i18nKeyModifier?: string) {
        super("manual", ManualSelectionItem.ID, value, disabledReason, i18nKeyModifier);
    }

    getSelectedTranslation() {
        return {
            key: `si.${this.translationKeyModifier}.options.manually-selected-with-number`,
            replacements: {
                numberOfItems: this.formatValue(),
            },
        };
    }

    getTranslation() {
        if (this.value === 0) {
            return {
                key: `si.${this.translationKeyModifier}.options.manually-selected`,
                replacements: {
                    numberOfItems: "",
                },
            };
        }

        return {
            key: `si.${this.translationKeyModifier}.options.manually-selected-with-number`,
            replacements: {
                numberOfItems: this.formatValue(),
            },
        };
    }
}
